import React from "react";
import { useLocation, useHistory, Route, Switch, Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";

import routes from "LoginRoutes.js";

const Auth = (props) => {
  const user = useSelector(state => state.userName);
  const history = useHistory();
  // console.log(user)
  if (user.toString().length !== 0) {
    history.push("/main/home");
  }
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="main-content" ref={mainContent}>
        <AuthNavbar />
        <div className="header justify-content-center bg-secondary py-7 py-lg-7 mobile-no-pt mobile-no-pb" style={{backgroundColor: 'pink'}}>
          <Container className="mobile-no-m">
            <div className="header-body text-center mb-6 mobile-no-m">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <h2 className="text-whitec no-w">Welcome!</h2>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        {/* Page content */}
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Switch>
              {getRoutes(routes)}
              <Redirect from="*" to="/auth/login" />
            </Switch>
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </>
  );
};

export default Auth;
